import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { Button, Icon, Tag } from '@wmgtech/legato'

import { relativeDate } from 'shared/utils/formatDate'

import { INotificationCardProps } from './NotificationCard.props'

import styles from './NotificationCard.module.scss'

export const NotificationCard: FC<INotificationCardProps> = ({
  onClickCard,
  title,
  subtitle,
  icon,
  imagePath,
  zone,
  date,
  elementsMeta,
  highlighted,
  onClear
}) => {
  return (
    <div onClick={onClickCard} className={cn(styles.card, { [styles.highlited]: highlighted })}>
      <div>
        {icon ? (
          <div className={styles.icon}><Icon name={icon} /></div>
        ) : (
          <img className={styles.image} src={imagePath} alt={title} />
        )}
      </div>
      <div>
        <div className={styles.title}>
          {title}
          {zone ?
            <Tag
              text={zone.alias}
              size={'xs'}
              removable={false}
              rounded
              colorType="white"
              containerStyle="outline"
              className={styles.tag}
              tooltip
              tooltipText={zone.name}
            /> : null
          }
        </div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
      <div className={styles.rightSide}>
        <div className={styles.meta}>
          <div>{elementsMeta}</div>
          {date && <div>{relativeDate(date)}</div>}
        </div>
        <Button
          className={styles.btn}
          containerStyle="link"
          colorType="info"
          onClick={(e) => {
            e.stopPropagation()
            onClear()
          }}
        >
          Clear
        </Button>
      </div>
    </div>
  )
}
